export const WHATSAPP_CONFIG = {
  MAX_RECONNECT_ATTEMPTS: 10,
  RECONNECT_DELAY: 1000, // Delay inicial en ms
  MAX_RECONNECT_DELAY: 30000, // Máximo delay en ms (30 segundos)
  RECONNECT_BACKOFF_FACTOR: 1.5, // Factor de incremento exponencial
  PONG_INTERVAL_MS: 30000, // Heartbeat cada 30 segundos
  BACKGROUND_RECONNECT_THRESHOLD_MS: 60000, // El navegador puede suspender timers en segundo plano
  CONNECTION_PROBE_TIMEOUT_MS: 3000, // Espera de respuesta del backend antes de dar el socket por muerto
  MAX_FILE_SIZE_MB: 16,
  ACCEPTED_FILE_TYPES: {
    IMAGES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    VIDEOS: ['video/mp4', 'video/avi', 'video/mov', 'video/webm'],
    AUDIO: ['audio/mp3', 'audio/wav', 'audio/ogg', 'audio/aac', 'audio/m4a'],
    DOCUMENTS: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
  },
}

// Codigo de cierre (rango privado 4000-4999) que manda el backend al socket
// que queda desplazado cuando el mismo usuario abre una conexion nueva
// (SESSION_REPLACED_CLOSE_CODE en kafka_whatsapp_service.py). No es una caida
// de red: reconectar desplazaria a su vez a la sesion nueva y las dos entrarian
// en un bucle, porque ambas tienen un JWT valido. Con este codigo se corta la
// reconexion y se devuelve al agente al login.
export const SESSION_REPLACED_CLOSE_CODE = 4001

// Identificador de la pestana "Mis chats" de la lista. No es un ChatStatus
// —agrupa ATENTION e IN_PROGRESS—, y viaja en la query cuando otra pantalla
// pide esa pestana, asi que vive aqui y no como literal en cada sitio.
export const MY_CHATS_TAB_ID = 'assigned'

// Colores de los filtros de la lista de chats. Viven aqui porque los reusan
// otras vistas —la insignia del sidebar, la barra de campanas— y un mismo
// concepto tiene que verse igual en todas.
export const CHAT_FILTER_COLORS = {
  PENDING_REPLY: '#F88C00',
  QUEUED: '#8A7CB8',
  ABANDONED: '#DA002C',
  EXPIRED: '#4A5565',
  TEMPLATES: '#FFD900',
}

export const ERROR_MESSAGES = {
  CONNECTION_FAILED: 'No se pudo conectar al servidor de WhatsApp',
  RECONNECTION_FAILED: 'Se alcanzó el máximo de intentos de reconexión',
  FILE_TOO_LARGE: 'El archivo es demasiado grande',
  INVALID_FILE_TYPE: 'Tipo de archivo no permitido',
  SEND_MESSAGE_FAILED: 'No se pudo enviar el mensaje',
  USER_NOT_FOUND: 'No se encontró el ID de usuario',
}

export const AVATAR_COLORS = [
  'from-green-400 to-green-600',
  'from-blue-400 to-blue-600',
  'from-purple-400 to-purple-600',
  'from-pink-400 to-pink-600',
  'from-yellow-400 to-yellow-600',
  'from-red-400 to-red-600',
  'from-indigo-400 to-indigo-600',
  'from-teal-400 to-teal-600',
]

export const getAvatarColor = (name: string): string => {
  const index = name.charCodeAt(0) % AVATAR_COLORS.length
  return AVATAR_COLORS[index]
}
